<ds-themed-root
  [shouldShowFullscreenLoader]="(isAuthBlocking$ | async) || (isThemeLoading$ | async)"
  [shouldShowRouteLoader]="isRouteLoading$ | async"></ds-themed-root>
